import React from "react";
import { CloseOutlined, EditTwoTone, SaveOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row, Select } from "antd";
import { PracticeUpdateTypes } from "../../Services/PracticesService";
import { Utils } from "../../Utilities/Utils";
import { adminContext } from "../../Common/PageRoute";

const BankAccount = ({
  form,
  isEdit,
  setIsEdit,
  OnSaveClick,
  OnCancelClick,
  handleValuesChange,
  isInactive,
}: any) => {
  return (
    <Form form={form} disabled={true} onValuesChange={handleValuesChange}>
      <Col className="card border pb-3 border-rounded-1 bg-secondary">
        <Row
          className="border-bottom pt-1 pb-3 px-2 font-bold"
          justify="space-between"
        >
          Bank Account
          {/* <Button
            icon={<EditTwoTone />}
            type="text"
            disabled={isInactive}
            style={{ border: "none" }}
            onClick={() =>
              setIsEdit({ type: PracticeUpdateTypes.bankAccountDetails })
            }
          /> */}
        </Row>
        <Row className="px-3 pt-1">
          <Col span={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
              label="Account name"
              name={["bankAccount", "accountName"]}
            >
              <Input
                // disabled={
                //   isEdit.type === PracticeUpdateTypes.bankAccountDetails
                //     ? false
                //     : true
                // }
                onKeyPress={(e: any) => Utils.ValidateCharOnly(e)}
                className="line-height-28"
                placeholder="Account name"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 18 }}
              label="Bank name"
              name={["bankAccount", "bankName"]}
            >
              <Input
                disabled={
                  isEdit.type === PracticeUpdateTypes.bankAccountDetails
                    ? false
                    : true
                }
                onKeyPress={(e: any) => Utils.ValidateCharOnly(e)}
                className="line-height-28"
                placeholder="Bank name"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 8 }}
              label="Sort code"
              name={["bankAccount", "shortCode"]}
            >
              <Input
                disabled={
                  isEdit.type === PracticeUpdateTypes.bankAccountDetails
                    ? false
                    : true
                }
                onKeyPress={(e) => Utils.ValidateNumberOnly(e)}
                className="line-height-28"
                placeholder="Sort code"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row className="px-3">
          <Col span={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
              label="Account number"
              name={["bankAccount", "accountNumber"]}
            >
              <Input
                disabled={
                  isEdit.type === PracticeUpdateTypes.bankAccountDetails
                    ? false
                    : true
                }
                onKeyPress={(e) => Utils.ValidateNumberOnly(e)}
                maxLength={8}
                className="line-height-28"
                placeholder="Accouint number"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 18 }}
              label="IBAN"
              name={["bankAccount", "iban"]}
            >
              <Input
                disabled={
                  isEdit.type === PracticeUpdateTypes.bankAccountDetails
                    ? false
                    : true
                }
                className="line-height-28"
                placeholder="IBAN"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 8 }}
              label="BIC code"
              name={["bankAccount", "bik"]}
            >
              <Input
                disabled={
                  isEdit.type === PracticeUpdateTypes.bankAccountDetails
                    ? false
                    : true
                }
                className="line-height-28"
                placeholder="BIC code"
              />
            </Form.Item>
          </Col>
        </Row>
        {isEdit.type === PracticeUpdateTypes.bankAccountDetails && (
          <Row className="px-3 pt-3">
            <Button type="primary" onClick={OnSaveClick}>
              <SaveOutlined /> Save
            </Button>
            <Button className="ms-2" onClick={OnCancelClick}>
              <CloseOutlined /> Cancel
            </Button>
          </Row>
        )}
      </Col>
    </Form>
  );
};

export default BankAccount;
